import { render, staticRenderFns } from "./AttendanceTeacherList.vue?vue&type=template&id=b0ae1634"
import script from "../../controllers/attendance_teacher/attendance-teacher-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/attendance_teacher/attendance-teacher-list.js?vue&type=script&lang=js&external"
import style0 from "./AttendanceTeacherList.vue?vue&type=style&index=0&id=b0ae1634&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports